/* eslint-disable */
import Setting from '@/setting';
import datetime from './util.datetime';

const list = {};

/**
 * @description 处理列
 * @param {String} _self 实例
 * @param {String} colList 列数据
 */
list.handleColList = function(_self, colList, type = 0) {
    let columns2 = []; //查看
    let columns3 = []; //新增/编辑
    for (let index = 0; index < colList.length; index++) {
        const element = colList[index];
        element.render = null; //不使用自定义列模板
        element.type = element.type1;
        element.type2 = element.type1; //搜索类型
        if (element.width == 0) {
            //自动宽度
            element.width = 'auto';
        }
        // console.log('element.type', element.type);
        //返回的是字符串,需要重新赋值自定义列模板
        if (element.type === 'input') {
            element.render = (h, params) => {
                return h('Input', {
                    props: {
                        value: params.row[element.key],
                        size: 'small',
                    },
                    style: {},
                    on: {
                        'on-blur': (e) => {
                            if (params.row[element.key] !== e.target.value) {
                                params.row[element.key] = e.target.value;
                                _self.formData = params.row;
                                _self.addModel = 1;
                                _self.handleCreate(
                                    'GoodsController',
                                    params.row
                                );
                                // _self.$refs.table.formData = params.row
                                // _self.$refs.table.addModel = 1
                                // _self.$refs.table.handleCreate()
                            }
                        },
                    },
                });
            };
        } else if (
            element.type === 'inputNumber' ||
            element.type === 'number'
        ) {
            if (true) {
                element.render = (h, params) => {
                    return h(
                        'div',
                        {
                            style: {},
                        },
                        [
                            h(
                                'span',
                                {
                                    style: {},
                                    props: {
                                        'v-clipboard:copy': _self.copyText,
                                    },
                                    on: {
                                        click: (e) => {
                                            _self
                                                .$copyText(
                                                    params.row[element.key]
                                                )
                                                .then(
                                                    function(e) {
                                                        _self.$Message.success(
                                                            '复制成功'
                                                        );
                                                    },
                                                    function(e) {
                                                        _self.$Message.warning(
                                                            '复制失败'
                                                        );
                                                    }
                                                );
                                            return false;
                                        },
                                    },
                                },
                                params.row[element.key]
                            ),
                        ]
                    );
                };
            } else {
                element.render = (h, params) => {
                    return h('InputNumber', {
                        props: {
                            value: params.row[element.key],
                            size: 'small',
                        },
                        style: {},
                        on: {
                            'on-blur': (e) => {
                                if (
                                    params.row[element.key] !== e.target.value
                                ) {
                                    params.row[element.key] = e.target.value;
                                    _self.formData = params.row;
                                    _self.addModel = 1;
                                    _self.handleCreate(
                                        'GoodsController',
                                        params.row
                                    );
                                    // _self.$refs.table.formData = params.row
                                    // _self.$refs.table.addModel = 1
                                    // _self.$refs.table.handleCreate()
                                }
                            },
                        },
                    });
                };
            }
        } else if (element.type === 'date' || element.type === 'datetime') {
            element.render = (h, params) => {
                // console.log('element.type', element.type)
                return h(
                    'div',
                    {
                        style: {},
                    },
                    [
                        h(
                            'span',
                            {
                                style: {},
                                props: {
                                    'v-clipboard:copy': _self.copyText,
                                },
                                on: {
                                    click: (e) => {
                                        _self
                                            .$copyText(params.row[element.key])
                                            .then(
                                                function(e) {
                                                    _self.$Message.success(
                                                        '复制成功'
                                                    );
                                                },
                                                function(e) {
                                                    _self.$Message.warning(
                                                        '复制失败'
                                                    );
                                                }
                                            );
                                        return false;
                                    },
                                },
                            },
                            datetime.format(
                                params.row[element.key],
                                element.type
                            )
                        ),
                    ]
                );
            };
        } else if (element.type === 'textbox') {
            element.render = (h, params) => {
                return h(
                    'div',
                    {
                        style: {},
                    },
                    [
                        h(
                            'span',
                            {
                                style: {},
                                props: {},
                            },
                            params.row[element.key]
                        ),
                    ]
                );
            };
        } else if (element.type === 'richText') {
            element.render = (h, params) => {
                return h(
                    'Button',
                    {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            // marginRight: '10px'
                        },
                        on: {
                            click: () => {
                                // _self.addModel = 1
                                // _self.formData = JSON.parse(JSON.stringify(params.row))//深拷贝
                                // _self.showCreate = true
                                _self.$refs.table.addModel = 1;
                                _self.$refs.table.formData = JSON.parse(
                                    JSON.stringify(params.row)
                                ); //深拷贝
                                _self.$refs.table.showCreate = true;
                            },
                        },
                    },
                    '查看'
                );
            };
        } else if (element.type === 'switch') {
            element.render = (h, params) => {
                let title = '否';
                if (params.row[element.key] === true) {
                    title = '是';
                }
                return h('div', [
                    h('i-switch', {
                        props: {
                            type: 'primary',
                            size: 'small',
                            value: params.row[element.key] === true,
                        },
                        style: {
                            // marginRight: '10px'
                        },
                        // on: {
                        //     'on-change': (value) => {
                        //         if (value) {
                        //             params.row.Today = true;
                        //         } else {
                        //             params.row.Today = false;
                        //         }
                        //         this.formData = JSON.parse(
                        //             JSON.stringify(params.row)
                        //         );
                        //         this.addModel = 1;
                        //         this.handleSubmit();
                        //     },
                        // },
                    }),
                ]);
            };
            // element.render = (h, params) => {
            //     if (params.row[element.key] === true) {
            //         return h('span', '是');
            //     } else {
            //         return h('span', '否');
            //     }
            // };
        } else if (element.type === 'img') {
            //列表显示图片,编辑显示上传图片
            element.render = (h, params) => {
                return h('div', [
                    h('img', {
                        attrs: {
                            src: params.row[element.key],
                            width: '80px',
                        },
                        style: {
                            cursor: 'pointer',
                        },
                        on: {
                            click: () => {
                                _self.imgUrl = params.row[element.key].replace(
                                    '!220w',
                                    ''
                                );
                                _self.visible = true;
                            },
                        },
                    }),
                ]);
            };
        } else if (element.type === 'imgs') {
            //列表显示图片,编辑显示上传图片
            element.render = (h, params) => {
                let imgs = [];
                let imageList = eval(params.row[element.key]);
                if (imageList) {
                    imageList.forEach((element) => {
                        imgs.push(
                            h('img', {
                                attrs: {
                                    src: element.Url.replace('!220w', ''),
                                    width: '80px',
                                },
                            })
                        );
                    });
                }
                return h('div', imgs);
            };
        } else if (element.type === 'imageList') {
            //列表显示图片,编辑显示上传图片
            element.render = (h, params) => {
                let imgs = [];
                let imageList = eval(params.row[element.key]);
                if (imageList) {
                    imageList.forEach((element) => {
                        imgs.push(
                            h('img', {
                                attrs: {
                                    src: element.Url.replace('!220w', ''),
                                    width: '80px',
                                },
                            })
                        );
                    });
                }
                return h('div', imgs);
            };
        } else if (element.type === 'AddressModel') {
            element.render = (h, params) => {
                let addressModel = params.row[element.key];
                // console.log('addressModel', addressModel)
                return h('div', [
                    // h('span', '省: ' + addressModel.Province || ''),
                    // h('br'),
                    h('span', '姓名: ' + addressModel.Name || ''),
                    h('br'),
                    h('span', '手机: ' + addressModel.Mobile || ''),
                    h('br'),
                    h('span', '地址: ' + addressModel.Address),
                    // h('br'),
                ]);
            };
        } else if (element.type === 'goodsLib') {
            element.render = (h, params) => {
                return h('span', params.row.GoodsName);
            };
        } else if (element.type === 'pass') {
            element.render = (h, params) => {
                let status = '';
                if (params.row.Pass === null) {
                    status = '审核中';
                } else if (params.row.Pass === true) {
                    status = '审核通过';
                } else if (params.row.Pass === false) {
                    status = '被驳回';
                }
                return h('div', [h('span', status)]);
            };
        } else if (element.type === 'list') {
            element.render = (h, params) => {
                return h(
                    'Button',
                    {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            // marginRight: '10px'
                        },
                        on: {
                            click: () => {
                                // _self.$refs.table.tableName1 = element.ModelName
                                // _self.$refs.table.currId = params.row._id || params.row.Id
                                // _self.$refs.table.loadTableData2(element.key)
                                // _self.$refs.table.showList = true
                                _self.tableName1 = element.ModelName;
                                _self.currId = params.row._id || params.row.Id;
                                _self.currField = element.key;
                                _self.loadTableData2();
                                _self.showList = true;
                            },
                        },
                    },
                    '查看'
                );
            };
        } else {
            // element.type = 'input'; //列表显示文本,编辑显示文本框
            if (!element.type1) {
                element.type1 = 'input';
            }
            element.type = element.type1; //列表显示文本,编辑显示文本框
            element.render = (h, params) => {
                return h(
                    'div',
                    {
                        style: {
                            style: {
                                // color: '#FF0041',
                                cursor: 'pointer',
                            },
                        },
                    },
                    [
                        h(
                            'span',
                            {
                                style: {},
                                props: {
                                    'v-clipboard:copy': _self.copyText,
                                },
                                on: {
                                    click: (e) => {
                                        _self
                                            .$copyText(params.row[element.key])
                                            .then(
                                                function(e) {
                                                    _self.$Message.success(
                                                        '复制成功'
                                                    );
                                                },
                                                function(e) {
                                                    _self.$Message.warning(
                                                        '复制失败'
                                                    );
                                                }
                                            );
                                        return false;
                                    },
                                },
                            },
                            params.row[element.key]
                        ),
                    ]
                );
            };
        }
        if (element.List) {
            element.Show = true;
            columns2.push(element);
        }
        if (element.Add) {
            columns3.push(element);
        }
    }
    if (type === 1) {
        return columns3;
    }
    return columns2;
};

export default list;
